export const lerTextoEmVoz = async (
  texto: string,
  lang = 'pt-BR'
  // vozNome: string = 'Google português do Brasil'
) => {
  if (typeof window === 'undefined' || !window.speechSynthesis) {
    console.error('Este ambiente não suporta a Web Speech API');
    return;
  }

  const utterance = new SpeechSynthesisUtterance(texto);
  utterance.lang = lang;
  utterance.rate = 1.1;
  utterance.pitch = 0.9;

  const carregarVozes = (): Promise<SpeechSynthesisVoice[]> => {
    return new Promise((resolve) => {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length) {
        resolve(voices);
      } else {
        window.speechSynthesis.onvoiceschanged = () =>
          resolve(window.speechSynthesis.getVoices());
      }
    });
  };

  const vozes = await carregarVozes();
  const voz = vozes.find((v) => v.lang === lang);

  if (voz) utterance.voice = voz;
  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(utterance);
};

export const cancelarVoz = async () => {
  if (typeof window === 'undefined' || !window.speechSynthesis) {
    console.error('Este ambiente não suporta a Web Speech API');
    return;
  }

  window.speechSynthesis.cancel();
};
